import React from "react";

export class TableHeader extends React.Component {
  render() {
    // Expected ["Value 1",...,"Value N"]
    const mappingContents = this.props.contents.map((value) => (
      <th scope="col"> {value} </th>
    ));
    return <tr>{mappingContents}</tr>;
  }
}
